import React, { useState } from "react";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Paginator } from "primereact/paginator";
import CustomOverlay from "shared/components/CustomOverlay";

const TableContainer = ({
    dataKey,
    list,
    columns,
    allowExpansion,
    rowExpansionTemplate,
    expandedRows,
    setExpandedRows,
    onApplyFilter,
    onClearFilter,
    selectionMode,
    notShowCount,
    selectedItems,
    count,
    onPageChange,
    first,
    rows,
    outOf,
    header,
    onDelete,
    onEdit,
    notShowActions,
    CustomTemplate,
    customActions
}) => {
    const filterApplyTemplate = (options) => {
        return (
            <Button
                type="button"
                // icon="pi pi-check"
                // onClick={options.filterApplyCallback}
                onClick={() => {
                    onApplyFilter
                        ? onApplyFilter(options)
                        : options.filterApplyCallback();           
                }}
                className="bg-primary-color"
            >
                Apply
            </Button>
        );
    };

    const filterClearTemplate = (options) => {
        return (
            <Button
                type="button"
                // icon="pi pi-times"
                // onClick={() => options.filterClearCallback("")}
                onClick={() => {
                    onClearFilter
                        ? onClearFilter(options)
                        : options.filterClearCallback("");
                }}
                className="clear-button-outlined"
            >
                Clear
            </Button>
        );
    };

    const ActionTemplate = () => {
        return (
            <>
                <p className="flex gap-2 align-items-center">Action</p>
            </>
        );
    };

    const actions = (d) => {
        return (
            <CustomOverlay extraClass={"text-center"}>
                <ul className="no-style p-0">
                    <li
                        className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                        onClick={() => onEdit && onEdit(d?._id)}
                    >
                        <i className="pi pi-pen-to-square cursor-pointer text-dark"></i>
                        Edit
                    </li>
                    <li
                        className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                        onClick={() => {
                            onDelete && onDelete(d?._id);
                        }}
                    >
                        <i className="pi pi-trash  text-dark"></i>{" "}
                        Delete
                    </li>
                </ul>
            </CustomOverlay>
        );
    };
    return (
        <>
            <DataTable
                value={list || []}
                dataKey={dataKey || "_id"}
                onRowToggle={(e) => setExpandedRows(e?.data)}
                expandedRows={expandedRows}
                rowExpansionTemplate={rowExpansionTemplate}
                header={header}
            >
                {allowExpansion && (
                    <Column expander style={{ width: '3rem' }} />
                )}
                {columns?.map((col, index) => {
                    return (
                        <Column
                            key={index}
                            headerClassName="custom-header capitalize-first-letter"
                            filterField={col?.accessor}
                            field={col?.accessor}
                            header={col?.name}
                            frozen={col?.frozen}
                            sortable={col?.sortable}
                            filter={col?.filter}
                            filterElement={col?.filterElement}
                            filterMenuStyle={{ width: "14rem" }}
                            style={{ minWidth: "180px" }}
                            className={`capitalize-first-letter ${col?.className || ""}`}
                            filterClear={filterClearTemplate}
                            filterApply={filterApplyTemplate}
                            body={col?.body}
                            showFilterMenuOptions={false}
                            showFilterMatchModes={false}
                        />
                    )
                })}
                {!notShowActions && <Column
                    headerClassName="custom-header"
                    body={customActions || actions}
                    style={{ width: "80px" }}
                    header={CustomTemplate || ActionTemplate}
                    alignFrozen="right"
                    frozen={true}
                />}
            </DataTable>
            <div className="flex flex-wrap mt-2 align-items-center">
                {(!notShowCount) && (outOf) ? <span className="text-gray-600">
                    {outOf || 0} out of {count || 0}
                </span> :
                    (selectionMode == "Multiple") && <span className="text-gray-600">
                        {selectedItems?.length || 0} out of {count || 0}
                    </span>
                }
                {onPageChange && (
                    <Paginator
                        className="mx-auto justify-content-center"
                        first={Number(first)}
                        rows={Number(rows)}
                        totalRecords={Number(count)}
                        rowsPerPageOptions={[10, 20, 50]}
                        onPageChange={onPageChange}
                    // lazy
                    ></Paginator>
                )}
            </div>
        </>
    )
}

export default TableContainer